import { setCookie } from "./cookies";

window.addEventListener("pageshow", function (event) {
    const rangeSliders = document.querySelectorAll('.rangeSlider');

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function updateSlider(slider, valueDisplay) {
        const percentage = ((slider.value - slider.min) / (slider.max - slider.min)) * 100;
        slider.style.background = `linear-gradient(to right, #7B1296 0%, #7B1296 ${percentage}%, #d3d3d3 ${percentage}%)`;
        if (valueDisplay) {
            valueDisplay.textContent = numberWithCommas(slider.value);
        }
    }

    rangeSliders.forEach(slider => {
        let valueDisplay = slider.parentElement.querySelector('.rangeValue');

        slider.addEventListener('input', function () {
            updateSlider(this, valueDisplay);
        });

        updateSlider(slider, valueDisplay);
    });
});


/**
 * 
 * @param {number} amount 
 * @return {array} allowed terms
 */
export function getAllowedTerms(amount) {
    if (amount < 1000) {
        return [3, 6, 12];
    } else if (amount == 1000) {
        return [3, 6, 12, 18, 24, 36];
    } else if (amount > 1000 && amount <= 2000) {
        return [6, 12, 18, 24, 36];
    } else if (amount >= 2000 && amount <= 2500) {
        return [6, 12, 18, 24, 36];
    } else if (amount > 2500 && amount <= 7500) {
        return [12, 18, 24, 36, 48, 60];
    } else if (amount >= 7500 && amount <= 10000) {
        return [18, 24, 36, 48, 60];
    } else {
        return [12, 18, 24, 36, 48, 60];
    }
}

document.addEventListener("DOMContentLoaded", function() {
    const sliders = document.querySelectorAll('.rangeSlider');
    const termSelects = document.querySelectorAll('.termSelect');
    const purposeSelects = document.querySelectorAll('.purposeSelect');
    const numberWithCommas = x => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Updates the slider's visual appearance and value display
    function updateSlider(sliderElement) {
        const valueDisplay = sliderElement.closest('.slider-box').querySelector('.rangeValue');
        const percentage = ((sliderElement.value - sliderElement.min) / (sliderElement.max - sliderElement.min)) * 100;
        sliderElement.style.background = `linear-gradient(to right, #7B1296 0%, #7B1296 ${percentage}%, #d3d3d3 ${percentage}%)`;
        if(valueDisplay) valueDisplay.textContent = numberWithCommas(sliderElement.value);
        updateCookies(sliderElement);
    }

    // Updates the cookies with the current slider, term, and purpose values
    function updateCookies(sliderElement) {
        const container = sliderElement.closest('.slider-box');
        const termSelect = container.querySelector('.termSelect');
        const purposeSelect = container.querySelector('.purposeSelect');

        setCookie('clad_la', sliderElement.value);
        setCookie('clad_term', termSelect ? termSelect.value : '');
        setCookie('clad_purpose', purposeSelect ? purposeSelect.value : '');
    }

    // Updates the allowed terms based on the loan amount
    function updateLoanTerms(sliderElement, termSelect) {
        const allowedTerms = getAllowedTerms(parseInt(sliderElement.value, 10));
        let closestTerm = null;

        Array.from(termSelect.options).forEach(option => {
            const termValue = parseInt(option.value);
            option.disabled = !allowedTerms.includes(termValue);
            if (option.disabled) return;

            closestTerm = closestTerm === null || Math.abs(termValue - termSelect.value) < Math.abs(closestTerm - termSelect.value)
                ? termValue
                : closestTerm;
        });
        termSelect.value = allowedTerms.includes(parseInt(termSelect.value)) ? termSelect.value : closestTerm;
    }

    sliders.forEach((slider, index) => {
        const termSelect = termSelects[index];
        updateSlider(slider);
        updateLoanTerms(slider, termSelect);
        updateCookies(slider);
        slider.addEventListener('input', () => {
            updateSlider(slider);
            updateLoanTerms(slider, termSelect);
        });
    });

    termSelects.forEach((termSelect, index) => {
        updateLoanTerms(sliders[index], termSelect);
        termSelect.addEventListener('change', () => {
            updateLoanTerms(sliders[index], termSelect);
        });
    });

    purposeSelects.forEach((purposeSelect, index) => {
        purposeSelect.addEventListener('change', () => updateCookies(sliders[index]));
    });

    $('#termSelectMobile, #purposeSelectMobile').change(function() {
        updateCookies(document.getElementById('rangeSliderMobile'));
    });

    $('#termSelect, #purposeSelect').change(function() {
        updateCookies(document.getElementById('rangeSlider'));
    });
});

document.addEventListener("DOMContentLoaded", function() {
    var sliderCTA = document.getElementById("sliderCTA");
    var mobileAmountSlider = document.querySelector(".mobile-amount-slider");
    var isSliderActive = false; // Track the state of the slider

    // Toggle function for mobile slider
    function toggleSlider() {
        mobileAmountSlider.classList.toggle("active");
        $('body').removeClass('no-transition');
        isSliderActive = !isSliderActive;

        if (isSliderActive) {
            sliderCTA.textContent = "Get my personalised quote";
            sliderCTA.href = "/apply";
        } else {
            sliderCTA.textContent = "Start quote";
            sliderCTA.href = "#";
        }
    }
    if (sliderCTA) {
        sliderCTA.addEventListener("click", function (event) {
            if (!isSliderActive) {
                event.preventDefault();
                toggleSlider();
            }
        });
    }

    // Close the slider if clicking outside of it and reset to original state
    document.addEventListener("click", function (event) {
        // Only proceed if the slider is active
        if (isSliderActive) {
            // Check if mobileAmountSlider is initialized and the clicked element is not part of the slider, nor the slider CTA
            if (mobileAmountSlider && !mobileAmountSlider.contains(event.target) && event.target !== sliderCTA) {
                toggleSlider();
            }
        }
    });
    //if the slider is present add z-index to main content
    if (document.querySelector('.amount-slider')) {
        document.querySelectorAll('.swifto-main-content, .main-top, .swifto-info-page, .main')
            .forEach(el => el.classList.add('amount-slider-present'));
        document.querySelector('main').classList.add('z-0', 'relative');
    }
});